import { render, staticRenderFns } from "./refuseDia.vue?vue&type=template&id=4dd1c568&scoped=true&"
import script from "./refuseDia.vue?vue&type=script&lang=js&"
export * from "./refuseDia.vue?vue&type=script&lang=js&"
import style0 from "./refuseDia.vue?vue&type=style&index=0&id=4dd1c568&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd1c568",
  null
  
)

export default component.exports